// api/connectionsClient.js
import axios from 'axios';
import TokenService from '../services/token.service';

/**
 * Cliente HTTP configurado para Connections Service (Meta/WhatsApp integrations)
 * Base URL: Configurado desde variable de entorno
 */
const connectionsClient = axios.create({
  baseURL: process.env.REACT_APP_CONNECTIONS_API_URL,
  timeout: 30000, // 30 segundos
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Interceptor para agregar JWT token automáticamente
 */
connectionsClient.interceptors.request.use(
  (config) => {
    const token = TokenService.getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Interceptor para manejar errores de respuesta
 */
connectionsClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Token expirado o inválido
    if (error.response?.status === 401) {
      console.error('❌ Token inválido o expirado en Connections Service');
      // No redirigir automáticamente, dejar que el componente maneje el error
    }

    // Log de errores para debugging
    if (error.response) {
      console.error('Connections API Error:', {
        status: error.response.status,
        data: error.response.data,
        url: error.config?.url
      });
    }

    return Promise.reject(error);
  }
);

/**
 * Helper para manejar errores de API
 */
export const handleApiError = (error) => {
  if (error.response) {
    return {
      status: error.response.status,
      message: error.response.data?.message || error.response.data?.detail || 'Error en el servidor',
      data: error.response.data
    };
  } else if (error.request) {
    return {
      status: 0,
      message: 'No se pudo conectar con el servidor'
    };
  } else {
    return {
      status: 0,
      message: error.message || 'Error desconocido'
    };
  }
};

export default connectionsClient;
